import { render, staticRenderFns } from "./BGamingFreespins.vue?vue&type=template&id=cff7e6de&"
import script from "./BGamingFreespins.vue?vue&type=script&lang=js&"
export * from "./BGamingFreespins.vue?vue&type=script&lang=js&"
import style0 from "./BGamingFreespins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports